<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <b-card no-body>
      <b-tabs card content-class="mt-3">
        <b-tab
          title="Story"
          :title-link-class="{
            'bg-warning': item.epic,
          }"
          active
        >
          <o-widget-wrapper
            :schema="schema"
            name="project"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-select
              v-model="item.project"
              :items="optionOcomProjectItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              :form-state="formState"
              :loading="optionOcomProjectWorking"
              name="project"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.project"
              allow-add
              store-name="OcomProject"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <ocom-project-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></ocom-project-form>
              </template>
            </o-select>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="roles"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.roles"
              :form-state="formState"
              name="roles"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.roles"
            ></o-text-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="capability"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <ox-html-area
              v-model="item.capability"
              :form-state="formState"
              name="capability"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.capability"
            ></ox-html-area>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="benefit"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <ox-html-area
              v-model="item.benefit"
              :form-state="formState"
              name="benefit"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.benefit"
            ></ox-html-area>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="epic"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.epic"
              :form-state="formState"
              name="epic"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.epic"
            ></o-checkbox>
          </o-widget-wrapper>
        </b-tab>
        <b-tab title="Acceptance">
          <template #title> Acceptance </template>
          <o-widget-wrapper
            :schema="schema"
            name="acceptance_criteria"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-html-area
              v-model="item.acceptance_criteria"
              :form-state="formState"
              name="acceptance_criteria"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.acceptance_criteria"
            ></o-html-area>
          </o-widget-wrapper>
        </b-tab>
        <b-tab title="Sprint">
          <o-widget-wrapper
            :schema="schema"
            name="story_points"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-select
              v-model="item.story_points"
              dont-sort
              :items="story_points_list"
              sort-field="id"
              :form-state="formState"
              name="story_points"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.story_points"
            ></o-select>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="priority"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.priority"
              :form-state="formState"
              name="priority"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.priority"
            ></o-text-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="schedule_week"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-date-time
              v-model="item.schedule_week"
              name="schedule_week"
              v-bind="schema.fields.schedule_week"
              :form-state="formState"
              :validators="$v.item"
              :server-errors="_se"
              hide-time
            ></o-date-time>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="status"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-select
              v-model="item.status"
              :items="optionCodeUserStoryStatusItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              :form-state="formState"
              :loading="optionCodeUserStoryStatusWorking"
              name="status"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.status"
              allow-add
              store-name="CodeUserStoryStatus"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-user-story-status-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></code-user-story-status-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </b-tab>
      </b-tabs>
    </b-card>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import { default as OcomProjectForm } from "../../ocom_project/components/ItemForm";
import { default as UserStoryForm } from "../../user_story/components/ItemForm";
import { default as CodeUserStoryStatusForm } from "../../code_user_story_status/components/ItemForm";
import OxHtmlArea from "@/app/components/OxHtmlArea";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("UserStory"),
    CreateCodeTableFetchMixin([
      "OcomProject",
      "UserStory",
      "CodeUserStoryStatus",
    ]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OxHtmlArea,

    OcomProjectForm,
    UserStoryForm,
    CodeUserStoryStatusForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.UserStory, {}),
    story_points_list: [
      { id: 1, description: "1 Point (XXS)" },
      { id: 2, description: "2 Points (XS)" },
      { id: 3, description: "3 Points (S)" },
      { id: 5, description: "5 Points (M)" },
      { id: 8, description: "8 Points (L)" },
      { id: 13, description: "13 Points (XL)" },
      { id: 21, description: "21 Points (XXL)" },
      { id: 34, description: "34 Points (XXXL)" },
    ],
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
